var map = {
	"./amazon-logo.svg": "eab7",
	"./apple-logo.svg": "dea6",
	"./dogecoin-logo.svg": "e915",
	"./eth-circle-logo.svg": "3b39",
	"./eth-dark-logo.svg": "486c",
	"./eth-logo.svg": "4cce",
	"./google-logo.svg": "5a46",
	"./google-play-logo.svg": "3f33",
	"./netflix-logo.svg": "e5a4",
	"./paypal-logo.svg": "aa7c",
	"./sales-force-logo.svg": "cae6",
	"./shibcoin-logo.svg": "c428",
	"./virgin-logo.svg": "4224",
	"./zendesk-logo.svg": "7bf3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2dc6";